import { useParams, useNavigate, useLoaderData } from 'react-router-dom';
import qs from 'qs';
import { Paper, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import configure from '@/constant/configure';
import { useTranslation } from 'react-i18next';

const Chat = () => {
    const { t } = useTranslation();
    const { userId = '-', mallId = '-' } = useParams();
    const { mallUserId = '' } = useLoaderData() as any;
    const queryString = qs.parse(location.search.split('?')[1] || '');
    const sourcingId = String(queryString?.sourcingId || '');
    const vendorId = String(queryString?.vendorId || '');
    const action = String(queryString?.action || '');
    return (
        <div className={'flex flex-col flex-1'}>
            <Grid container>
                <Grid xs={12}>
                    <Typography variant={'h1'} gutterBottom>
                        {t('sidebar.chat')}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid xs={12}>
                    <Paper className="flex-1 flex items-center justify-center" sx={{ height: '80vh' }}>
                        <iframe
                            src={`${configure.services.flowing_chat_url}/talks/seller?sellerId=${mallUserId}&sourcingId=${sourcingId}&vendorId=${vendorId}&action=${action}`}
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};
export default Chat;
